import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import type { DepositContext, DepositResult } from '../../../../../../types/Cashier';
import RejectedCommon from '../RejectedCommon/RejectedCommon';
import RejectedTransaction from '../RejectedTransaction/RejectedTransaction';

import { TXTWCL_SorryX_youXve_made_too_many_de_ELL } from './RejectMaxDepositsLimitExceeded.messages.json';

type Props = DepositResult & DepositContext;

const RejectMaxDepositsLimitExceeded: React.FC<Props> = ({ deposit, transactionId }) => (
  <>
    <RejectedCommon>
      <Translation {...TXTWCL_SorryX_youXve_made_too_many_de_ELL} />
    </RejectedCommon>
    <RejectedTransaction deposit={deposit} transactionId={transactionId} />
  </>
);

export default RejectMaxDepositsLimitExceeded;
